import { reactive, onMount } from 'cdui-js';
import { lastProcess, nextProcess, pState, getApplySaveExtra, setFormValidateFunc } from '../store';
import { CheckBoxCard } from '../../../components/CheckBoxCard';
import { LastNextBtns } from '../components/LastNextBtns';
import { saveApply } from '../../../../../api/open-account';
import { showToast } from '../../../components/Toast';
import i18n from '../../../../../i18n';

export const VerificationPoint = () => {
  const state = reactive({
    location: 0,
  });

  const validateFunc = async () => {
    if (!String(pState.offline.address || '').trim()) {
      showToast(i18n.OpenProgress.Offline.ToastWitnessRequired);
      return false;
    }
    return true;
  };

  onMount(() => {
    setFormValidateFunc({ callback: validateFunc });
  });

  return (
    <div class="padding-x-L margin-y-XL">
      <div class="font-s-L font-bold color-D margin-b-XXS">{i18n.OpenProgress.Offline.WitnessPointTitle}</div>
      <div class="color">{i18n.OpenProgress.Offline.WitnessPointDesc}</div>

      <div class="color-D font-bold margin-t-XL margin-b-XXS">{i18n.OpenProgress.Offline.CompanyWitness}</div>

      <CheckBoxCard
        active={pState.offline.address === pState.companyAddress}
        onclick={() => {
          state.location = 0;
          pState.offline.address = pState.companyAddress;
        }}
        class="round-XL"
      >
        <div class="flex align-center gap-12px padding">
          <div class="verification-point-cover round" style={{ width: '78px', height: '43px' }}></div>
          <div class="color-D flex-auto">{pState.companyAddress}</div>
        </div>
      </CheckBoxCard>

      <LastNextBtns
        last={() => {
          lastProcess();
        }}
        next={async () => {
          await saveApply({
            progress: 2,
            appointmentAddress: pState.offline.address || pState.companyAddress,
            applyType: 'NEW_APPLY',
            ...getApplySaveExtra(),
          });
          nextProcess();
        }}
      />
    </div>
  );
};
